import React from "react";
import { VintomError } from "src/api/model/error/VintomError";
import { I18n } from "../../../../i18n/i18n";
import { ScenarioElementPlaybackState } from "../../../../uiModel/playback/ScenarioElementPlaybackState";
import { LoaderIcon, PlayIcon, ReplayIcon, VolumeMutedIcon } from "../../../icons";
import { MessageComponent } from "../common/MessageComponent";

import "@styles/c-desktopOverlay.scss";

interface Props {
  // configuration: PlayerControls;
  i18n: I18n;
  isCTADisplayed: boolean;
  isPlayPauseEnabled: boolean;
  playbackState: ScenarioElementPlaybackState;
  isLoading: boolean;
  loaderTrigger: string;
  isVolumeMuted: boolean;
  onPlay: () => void;
  onReplay: () => void;
  onUnMute: () => void;
  message?: string | VintomError;
  onSendError: (error: VintomError) => void;
  playIconOnPoster: boolean;
  disableIcon: boolean;
}

export const DesktopOverlayComponent: React.FC<Props> = (props) => {
  const {
    i18n,
    isCTADisplayed,
    isPlayPauseEnabled,
    playbackState,
    isLoading,
    loaderTrigger,
    isVolumeMuted,
    onPlay,
    onReplay,
    onUnMute,
    message,
    onSendError,
    playIconOnPoster,
    disableIcon,
  } = props;

  const isControlDisplayed =
    !!message ||
    isLoading ||
    isVolumeMuted ||
    (isPlayPauseEnabled && ["paused", "looping", "scenarioFinished"].indexOf(playbackState) > -1 && !isCTADisplayed);

  if (!isControlDisplayed) {
    return <></>;
  }

  if (message) {
    return <MessageComponent i18n={i18n} message={message} onSendError={onSendError} />;
  }

  let isDisabled: boolean;
  let icon: React.ReactNode;
  let onClickCallback: () => void;

  if (isLoading) {
    isDisabled = true;
    icon = <LoaderIcon loaderTrigger={loaderTrigger} />;
    onClickCallback = () => {};
  } else if (playIconOnPoster === true && disableIcon) {
    return <></>;
  } else if (playbackState === "paused" || playbackState === "looping") {
    isDisabled = false;
    icon = <PlayIcon />;
    onClickCallback = onPlay;
  } else if (playbackState === "scenarioFinished") {
    isDisabled = false;
    icon = <ReplayIcon />;
    onClickCallback = onReplay;
  } else {
    isDisabled = false;
    icon = <VolumeMutedIcon />;
    onClickCallback = onUnMute;
  }

  return (
    <button
      className="c-desktopOverlay"
      disabled={isDisabled}
      onClick={(event) => {
        onClickCallback();
      }}
    >
      {icon}
    </button>
  );
};
